var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0,
    strokeMiterlimit: 10,
    fill: "none",
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.983 19.329c.053-.4.056-.798-.006-1.19-.008-.06-.003-.115-.014-.174a4.222 4.222 0 00-.512-1.294c-.026-.045-.028-.092-.054-.137-.042-.067-.109-.101-.154-.165-.095-.135-.168-.286-.283-.41-.142-.156-.316-.271-.476-.403-.086-.07-.162-.151-.252-.213a4.162 4.162 0 00-1.22-.585c-.08-.022-.158-.025-.236-.042a4.135 4.135 0 00-1.132-.095c-.128.005-.249.017-.378.033-.109.017-.221.006-.33.028L5.266 69.175A4.207 4.207 0 002.02 72.7a4.202 4.202 0 002.17 4.271l65.884 35.461 20.521 65.427c.023.07.07.12.096.187.058.157.145.297.224.449.165.319.355.61.59.873.062.07.085.16.152.225.061.058.14.078.204.134.278.24.58.434.91.597.132.064.247.148.381.196.46.17.942.28 1.448.28h.093a4.129 4.129 0 001.425-.3c.115-.045.21-.123.32-.176.355-.177.683-.39.977-.659.056-.05.13-.067.182-.123l33.635-34.195 64.923 34.946a4.205 4.205 0 003.551.204 4.205 4.205 0 002.434-2.593l51.7-157.811c.04-.124.042-.252.07-.379.03-.128.056-.254.073-.386zm-35.14 10.693L73.609 104.801 18.091 74.916l200.753-44.894zm-8.724 13.946l-105.05 80.581c-.008.006-.013.017-.019.023a4.11 4.11 0 00-.823.88c-.05.07-.098.14-.143.212-.048.079-.11.146-.154.227a4.12 4.12 0 00-.342.865c-.003.014-.014.026-.017.04l-9.293 34.75-15.645-49.88L210.12 43.968zM102.77 162.307l7.543-28.21 13.211 7.112-20.754 21.098zm92.945 8.22l-80.377-43.264L241.626 30.39l-45.911 140.138zM38.094 241.382a4.192 4.192 0 01-2.946-1.207 4.2 4.2 0 01-.05-5.94l40.028-40.69a4.2 4.2 0 015.941-.051 4.2 4.2 0 01.05 5.94l-40.026 40.693a4.188 4.188 0 01-2.997 1.255z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 224.888a4.192 4.192 0 01-2.946-1.207 4.2 4.2 0 01-.05-5.94l40.025-40.688a4.202 4.202 0 015.991 5.89l-40.023 40.69a4.2 4.2 0 01-2.997 1.255zM25.589 190.259a4.192 4.192 0 01-2.947-1.207 4.2 4.2 0 01-.05-5.94l29.254-29.74a4.202 4.202 0 015.991 5.89l-29.251 29.74a4.19 4.19 0 01-2.997 1.257z",
    fill: "#000"
  }))));
}

export default SvgIconPlane;